import React from 'react';
import { Paper, Typography } from '@material-ui/core';
import styles from './styles.module.scss';
import { App, ServerFeature } from '../../../../models/app';
import { useTranslation } from 'react-i18next';
import { EntityState } from '@reduxjs/toolkit';
import { checkAllowedDevicetypes, displaySupportedDevices } from './deviceServerFeaturesHelper';

interface ComponentProps {
  app: App;
  deviceServerFeatures: EntityState<ServerFeature>;
}

export const AppsAvailableOn: React.FC<ComponentProps> = ({ app, deviceServerFeatures }): JSX.Element => {
  const { t } = useTranslation();
  const { deviceTypes, siteUrl, packageName } = app;
  const isAndroid = !!packageName && !!packageName.trim();
  const deviceNames : Array<string> = deviceTypes ? deviceTypes?.elements.filter(type => !!type.name).map(type => type.name) ?? [] : [];
  const deviceTypesToDisplay = checkAllowedDevicetypes(deviceNames);
  const numberOfDeviceTypesToDisplay =  displaySupportedDevices(deviceServerFeatures,deviceTypesToDisplay).length;
  const showAvailableOn = (isAndroid && numberOfDeviceTypesToDisplay > 0) || !!siteUrl;
  return (
	<>
    {showAvailableOn && <Paper square className={styles.appsAvailableOnWrapper}>
      <h4>
        {t('app_details.available_on')}
      </h4>
      <div className={numberOfDeviceTypesToDisplay > 3 ? styles.devices_two_cols : styles.devices_one_cols}>
        {isAndroid &&
          deviceServerFeatures &&
          displaySupportedDevices(deviceServerFeatures, deviceTypesToDisplay).map(displayDeviceName => (
            <Typography gutterBottom noWrap key={displayDeviceName} data-testid='deviceSupport'>
              {t(`${displayDeviceName}`)}
            </Typography>
          ))}
        {!!siteUrl && <Typography gutterBottom data-testid='webSupport'>{t('web')}</Typography>}
      </div>
    </Paper>}
	</>
  );
};
